<template>
  <div id="DopasujObudowe">
    <h3>{{$t('message.dopasowanie_obudowy')}}</h3>
    <div v-if="selectedElements && selectedElements.obudowa && Object.keys(selectedElements.obudowa.rzuty).length > 1">
      {{$t('message.widok')}}:
      <ul class="navView">
        <li v-for="rzut in selectedElements.obudowa.rzuty" :key="rzut" @click="zmienWidok(rzut)"
        :class="(rzut === widok) ? 'activeView' : ''"
        >{{buttonText[rzut]}}</li>
      </ul>
    </div>

    <div style="max-width: 1200px; margin: 0px auto; display: inline-flex">
      <div class="kolumna-1">
        <fieldset v-if="Object.keys(selectedObudowa).length > 0">
          <legend style="width: 160px">{{$t('message.wybrana_obudowa')}}</legend>
          <div
            v-if="Object.keys(selectedObudowa).length > 0"
            class="md-layout-item"
          >
            <!-- <h3>Wybrana obudowa</h3> -->
            <div id="selected-obudowa">
              <p>{{ selectedObudowa.symbol }}</p>
              <p>{{ selectedObudowa.nazwa }}</p>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <legend style="width: 190px">{{$t('message.centrala_moduly')}}</legend>
          <div class="md-layout-item">
            <!-- <h3>Producent</h3> -->
            <multiselect
              v-model="inputFields.producent"
              :options="Dystrybutorzy"
              :multiple="false"
              label=""
              track-by=""
              :placeholder="$t('message.producent')"
              selectLabel=""
              selectedLabel=""
              deselectLabel=""
              :showNoResults="false"
              :allow-empty="false"
              @input="clickProducent()"
              :class="'inputSelectProducent'"
            >
            </multiselect>
          </div>

          <div class="md-layout-item inSelect">
            <!-- <h3>Centrala</h3> -->
            <multiselect
              v-model="inputFields.centrala"
              :options="centraleLista"
              :multiple="false"
              label="model"
              :placeholder="$t('message.centrala')"
              selectLabel=""
              selectedLabel=""
              deselectLabel=""
              :clear-on-select="true"
              :close-on-select="true"
              :showNoResults="false"
              :allow-empty="false"
              @input="clickCentrale($event)"
              :class="
                Object.keys(inputFields.centrala).length > 0
                  ? 'inputSelectCentrala'
                  : 'inputSelectProducent'
              "
            >
            </multiselect>

            <div v-if="Object.keys(inputFields.centrala).length > 0" @click="clickEye('centrala')" class="oko">
              <svg
                v-if="!eyes.includes('centrala')"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                class="bi bi-eye-fill"
                viewBox="0 0 16 16"
              >
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path
                  d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                class="bi bi-eye-slash"
                viewBox="0 0 16 16"
              >
                <path
                  d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"
                />
                <path
                  d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"
                />
                <path
                  d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"
                />
              </svg>
            </div>
          </div>
          <div
            class="md-layout-item inSelect"
            v-for="(mod, indexMod) in countBoxModules"
            :key="indexMod"
          >
            <!-- <h3>Moduły</h3> -->
            <multiselect
              v-model="inputFields.moduly[indexMod]"
              :options="modulyLista"
              :multiple="false"
              label="model"
              :placeholder="$t('message.modul')"
              selectLabel=""
              selectedLabel=""
              deselectLabel=""
              :showNoResults="false"
              :allow-empty="false"
              @input="clickModul($event)"
              :class="
                inputFields.moduly[indexMod]
                  ? 'inputSelect' + indexMod
                  : 'inputSelectProducent'
              "
            >
            </multiselect>
            <div
              v-if="inputFields.moduly[indexMod]"
              class="oko"
              @click="clickEye('modul-' + indexMod)"
            >
              <svg
                v-if="!eyes.includes('modul-' + indexMod)"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                class="bi bi-eye-fill"
                viewBox="0 0 16 16"
                style="cursor: point"
              >
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                <path
                  d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                class="bi bi-eye-slash"
                viewBox="0 0 16 16"
              >
                <path
                  d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"
                />
                <path
                  d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"
                />
                <path
                  d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"
                />
              </svg>
            </div>

            <!-- <div v-if="selectedElements.moduly && selectedElements.moduly[indexMod] && selectedElements.moduly[indexMod].places && Object.keys(selectedElements.moduly[indexMod].places).length>0">
              <ul style="display: inline-block;width: 100%;text-align: left;padding: 6px;">
                <li v-for="modul,index in selectedElements.moduly[indexMod].places" :key="modul.model" style="list-style:none">
                  <input type="checkbox" :id="'cb'+indexMod+''+index" name="check" ref="theCheckbox"
                  :value="index"
                  v-model="additional[indexMod]"
                  @click="changeModuler($event, modul, index, indexMod)"
                  >
                  <label :for="'cb'+indexMod+''+index">umiejscowienie {{index + 1}} </label>
                </li>
              </ul>
            </div> -->
          </div>

          <!-- <button class="btn btn-success" @click="addModul()" v-if="this.inputFields.modulModel !== '' && this.inputFields.modulModel !== null" :disabled="(countBoxModules === 4) ? true : false" -->
          <button
            class="btn btn-success"
            @click="addModul()"
            v-if="Object.keys(inputFields.moduly).length > 0"
            :disabled="countBoxModules === 4 ? true : false"
            style="
              margin: 8px 2px;
              width: 37px;
              height: 25px;
              line-height: 10px;
              float: right;
              font-weight: bold;
              font-size: 21px;
              border-radius: 0px;
            "
          >
            +
          </button>
          <button
            class="btn btn-danger"
            @click="deleteModul()"
            v-if="countBoxModules > 1"
            style="
              margin: 8px 2px;
              width: 37px;
              height: 25px;
              line-height: 10px;
              float: right;
              font-weight: bold;
              font-size: 21px;
              border-radius: 0px;
            "
          >
            -
          </button>
        </fieldset>

        <fieldset v-if="Object.keys(obudowy).length > 0">
          <legend style="width: 240px">

           <legend style="width: 186px;margin-top: 0px;">{{$t('message.dopasowane_obudowy')}}</legend>
            <img
              v-if="filters && filters.montaz"
              @click="showFilters"
              src="../assets/filter.png"
              style="width: 20px; margin-left: 13px"
            />
          </legend>
          <!-- <div v-if="Object.keys(obudowy).length>0" class="md-layout-item">
            <h3>Dopasowane obudowy</h3>
          </div> -->

          <div
            id="cards"
            class="md-layout-item"
            style="margin: 20px 0px"
            v-if="
              Object.keys(inputFields.centrala).length > 0 ||
              Object.keys(inputFields.moduly).length > 0
            "
          >
            <div
              v-for="(obudowa, index) in obudowy"
              :key="index"
              @click="showView(obudowa)"
            >
              <md-card
                :class="[
                  selectedElements.obudowa &&
                  obudowa &&
                  obudowa.id_obudowa === selectedElements.obudowa.id_obudowa
                    ? 'active'
                    : '',
                ]"
                style="display: table"
              >
                <div style="float: left; width: 60px; height: 60px">
                  <img
                    @click="
                      (showDialog = true),
                        (sourceImg = obudowa.symbol + '_1.png')
                    "
                    :src="
                      'https://lib.pulsar.pl/img/thumbs/' +
                      obudowa.symbol +
                      '_1.png'
                    "
                    alt=""
                    style="max-width: 60px; max-height: 60px; cursor: zoom-in"
                  />

                  <div class="lupka">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-zoom-in"
                      viewBox="0 0 16 16"
                      style="100%"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"
                      />
                      <path
                        d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"
                      />
                    </svg>
                  </div>
                </div>
                <md-card-header style="">
                  <div class="md-title">{{ obudowa.symbol }}</div>
                  <!-- <div class="md-subhead">{{ obudowa.nazwa }}</div> -->
                </md-card-header>
                <!-- <div>
                  <ul style="display: inline-block;width: 100%;text-align: center;padding: 0px;">
                    <li v-for="modul,index in obudowa.moduly" :key="modul.model" style="list-style:none">
                      <input type="checkbox" id="john" name="check" :value="modul" v-model="additional" ref="theCheckbox" @click="changeModuler($event, modul)">
                      <label for="john">miejsce {{index + 1}} </label>
                    </li>
                  </ul>
                </div> -->
              </md-card>
            </div>
          </div>

          <div id="cards" class="md-layout-item" v-else>
            {{$t('message.brak_obudow')}}
          </div>
        </fieldset>
      </div>

      <!-- {{inputFields.modulPlaceIndex}} -->
      <div class="kolumna-2">
        <div>
          <Wizualizacja :eyes="eyes" :widokBtn='widokBtn' :widok='widok'/>
        </div>
        <!-- <Wizualizacja
          :obudowa="selectedObudowa"
          :plytka="selectedCentrala"
          :modul="selectedModul"
          :modulIndex = "inputFields.modulPlaceIndex"
        /> -->
        <div
          style="text-align: left"
          v-if="selectedElements.obudowa && Object.keys(selectedElements.obudowa).length > 0"
        >
          <h3 style="font-size: 14px">
            {{$t('message.strona_produktowa')}}
            <a
              :href="
                'https://www.pulsar.pl/PL_9999_' +
                selectedElements.obudowa.symbol +
                '_wyszukiwarka'
              "
              target="_new"
              >{{$t('message.zobacz')}}</a
            >
          </h3>
        </div>
      </div>
    </div>

    <md-dialog :md-active.sync="showDialog">
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false"
          ><span style="font-weight: bold">X</span></md-button
        >
      </md-dialog-actions>
      <img
        v-bind:src="photo"
        style="
          width: max-content;
          height: 100%;
          margin: 0px auto;
          padding: 20px;
        "
      />
    </md-dialog>

    <md-dialog :md-active.sync="showDialogFilters">

      <div v-if="loading">
        <app-loader />
      </div>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialogFilters = false"
          ><span style="font-weight: bold">X</span></md-button
        >
      </md-dialog-actions>

      <fieldset style="width: 300px" v-if="filters && filters.montaz">
        <legend style="width: 145px">{{$t('message.rodzaj_montazu')}}</legend>
        <md-checkbox
          @change="filtrujObudowy()"
          v-model="inputFilters.obudowaMontaz"
          value="64"
          class="md-primary inputCheckbox"
          :disabled="filters.montaz.includes('natynkowy') === false"
          >{{$t('message.natynkowa')}}</md-checkbox
        >
        <md-checkbox
          @change="filtrujObudowy()"
          v-model="inputFilters.obudowaMontaz"
          value="65"
          class="md-primary inputCheckbox"
          :disabled="filters.montaz.includes('podtynkowy') === false"
          >{{$t('message.podtynkowy')}}</md-checkbox
        >
        <md-checkbox
          @change="filtrujObudowy()"
          v-model="inputFilters.obudowaMontaz"
          value="371"
          class="md-primary inputCheckbox"
          :disabled="filters.montaz.includes('rack') === false"
          >rack</md-checkbox
        >
      </fieldset>

      <fieldset
        style="width: 300px"
        v-if="filters && filters.zasilanie && filters.moc"
      >
        <legend style="width: 275px">{{$t('message.trafo_zasilacz')}}</legend>
        <div style="width: 100%; display: block">
          <div style="width: 50%; display: grid; float: left">
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformator"
              value="12"
              class="md-primary inputCheckbox"
              :disabled="filters.zasilanie.includes(12) === false"
              >12 V AC</md-checkbox
            >
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformator"
              value="14"
              class="md-primary inputCheckbox"
              :disabled="filters.zasilanie.includes(14) === false"
              >14 V AC</md-checkbox
            >
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformator"
              value="16"
              class="md-primary inputCheckbox"
              :disabled="filters.zasilanie.includes(16) === false"
              >16 V AC</md-checkbox
            >
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformator"
              value="17"
              class="md-primary inputCheckbox"
              :disabled="filters.zasilanie.includes(17) === false"
              >17 V AC</md-checkbox
            >
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformator"
              value="18"
              class="md-primary inputCheckbox"
              :disabled="filters.zasilanie.includes(18) === false"
              >18 V AC</md-checkbox
            >
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformator"
              value="20"
              class="md-primary inputCheckbox"
              :disabled="filters.zasilanie.includes(20) === false"
              >20 V AC</md-checkbox
            >
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformator"
              value="24"
              class="md-primary inputCheckbox"
              :disabled="filters.zasilanie.includes(24) === false"
              >24 V AC</md-checkbox
            >
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformator"
              value="30"
              class="md-primary inputCheckbox"
              :disabled="filters.zasilanie.includes(30) === false"
              >30 V AC</md-checkbox
            >
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformator"
              value=""
              class="md-primary inputCheckbox"
              >brak</md-checkbox
            >
          </div>

          <div style="width: 50%; display: grid">
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformatorMoc"
              value="20"
              class="md-primary inputCheckbox"
              :disabled="filters.moc.includes(20) === false"
              >20VA</md-checkbox
            >
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformatorMoc"
              value="40"
              class="md-primary inputCheckbox"
              :disabled="filters.moc.includes(40) === false"
              >40VA</md-checkbox
            >
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformatorMoc"
              value="50"
              class="md-primary inputCheckbox"
              :disabled="filters.moc.includes(50) === false"
              >50VA</md-checkbox
            >
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformatorMoc"
              value="75"
              class="md-primary inputCheckbox"
              :disabled="filters.moc.includes(75) === false"
              >75VA</md-checkbox
            >
            <md-checkbox
              @change="filtrujObudowy()"
              v-model="inputFilters.obudowaTransformatorMoc"
              value="80"
              class="md-primary inputCheckbox"
              :disabled="filters.moc.includes(80) == false"
              >80VA</md-checkbox
            >
          </div>
        </div>
      </fieldset>

      <fieldset style="width: 300px" v-if="filters && filters.akumulatory">
        <legend style="width: 110px">{{$t('message.akumulator')}}</legend>
        <md-checkbox
          @change="filtrujObudowy()"
          v-model="inputFilters.obudowaAkumulator"
          value="7"
          class="md-primary inputCheckbox"
          :disabled="filters.akumulatory.includes(7) == false"
          >7Ah</md-checkbox
        >
        <md-checkbox
          @change="filtrujObudowy()"
          v-model="inputFilters.obudowaAkumulator"
          value="17"
          class="md-primary inputCheckbox"
          :disabled="filters.akumulatory.includes(17) == false"
          >17Ah</md-checkbox
        >
        <md-checkbox
          @change="filtrujObudowy()"
          v-model="inputFilters.obudowaAkumulator"
          value="24"
          class="md-primary inputCheckbox"
          :disabled="filters.akumulatory.includes(24) == false"
          >24Ah</md-checkbox
        >
      </fieldset>
    </md-dialog>
    <!-- {{additional}}
    {{inputFields.modulPlaceIndex}} -->
  </div>
</template>

<script>
import { app } from "../mixins/functions";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import Wizualizacja from "./Wizualizacja";

export default {
  name: "DopasujObudowe",
  mixins: [app],
  data() {
    return {
      selectedObudowa: [],
      selectedModul: [],
      selectedModuly: [],
      selectedCentrala: [],
      // centralaIndex: null,
      // centralaProducent: null,
      isDisabled: true,
      outputElements: {
        obudowy: [],
      },
      inputFields: {
        producent: "",
        centrala: [],
        moduly: [],
      },
      inputFilters: {
        obudowaMontaz: [],
        obudowaTransformator: [],
        obudowaTransformatorMoc: [],
        obudowaAkumulator: [],
      },
      expandSingleRodzajMontazu: false,
      expandRodzajMontazu: false,
      expandSingleTransformator: false,
      expandTransformator: false,
      expandSingleAkumulator: false,
      expandAkumulator: false,
      sourceImg: "",
      showDialog: false,
      showDialogFilters: false,
      tabName: "",
      additional: [],
      checkRerfresh: 0,
      countBoxModules: 1,
      eyes: []
    };
  },
  components: {
    Wizualizacja,
    Multiselect,
  },
  watch: {
    // obudowy (newValue, oldValue) {
    //   this.showView(newValue[0])
    // }
    // additional (newValue, oldValue) {
    //   if (newValue) {
    //     this.changeModuler(newValue)
    //   }
    // }
  },
  computed: {
    ...mapGetters("products", [
      "centrale",
      "obudowy",
      "moduly",
      "selectedElements",
      "filters",
      "loading"
    ]),
    photo() {
      return "https://lib.pulsar.pl/img/produkty/" + this.sourceImg;
    },
  },
  methods: {
    showView(obudowa) {
      console.log("----- showView -----");
      // console.log('obudowa', obudowa)
      // console.log('selectedElements', this.selectedElements)
      let nowaObudowa = Object.assign({}, obudowa);
      // let nowaCentrala= (Object.keys(this.selectedElements.centrala).length>0) ? Object.assign({}, this.selectedElements.centrala) : []
      // let noweModuly= (Object.keys(this.selectedElements.centrala).length>0) ? Object.assign({}, this.selectedElements.centrala) : []
      var obudowaID =
        Object.keys(nowaObudowa).length > 0 ? nowaObudowa.id_obudowa : [];
      var centralaID =
        this.selectedElements.centrala &&
        this.selectedElements.centrala.id_centrala
          ? this.selectedElements.centrala.id_centrala
          : [];
      var modulesID = [];
      if (
        this.selectedElements &&
        this.selectedElements.moduly &&
        Object.keys(this.selectedElements.moduly).length > 0
      ) {
        Object.values(this.selectedElements.moduly).forEach((item) => {
          modulesID.push(item.idmodul);
        });
      }
      this.widokBtn = false
      this.widok =  'C'

      this.$store.dispatch("products/get_selected_elements", {
        centrala: centralaID,
        moduly: modulesID,
        obudowa: obudowaID,
      });
    },
    zmianaZakladki(elem) {
      this.tabName = elem;
    },
    clickProducent() {
      console.log("----- clickProducent -----");
      this.isDisabled = false;
      // this.inputFields.centralaIndex = null;
      // this.inputFields.modulIndex = null;
      this.selectedCentrala = [];
      this.selectedModul = [];
      this.selectedModuly = [];
      this.selectedObudowa = [];
      this.$store.commit("products/SET_VAR_STATE", [
        this.inputFields.producent,
        "inputData",
        "producent",
      ]);
      this.$store.commit("products/SET_VAR_STATE", [
        null,
        "inputData",
        "model",
      ]);
    },
    clickCentrale(e) {
      console.log("----- clickCentrale -----");
      // console.log(this.inputFields.centrala)

      const idCentral = this.inputFields.centrala.idcentrala;
      const idModules = Object.keys(this.inputFields.moduly).length > 0 ? this.inputFields.moduly.map((modules) => modules.idmodul) : [];
      let idEnclousers = Object.keys(this.obudowy).length > 0 ? this.obudowy.map((enclosure) => enclosure.id_obudowa) : [];

      this.inputFields.producent = this.inputFields.centrala.producent;

      this.$store
        .dispatch("products/load_obudowy", {
          centrala: this.inputFields.centrala,
          moduly: [],
        })
        .then((item) => {
          idEnclousers =
            Object.keys(this.obudowy).length > 0
              ? this.obudowy.map((enclosure) => enclosure.id_obudowa)
              : [];
          this.$store
            .dispatch("products/load_moduly", {
              obudowa: idEnclousers,
              producent: this.inputFields.centrala.producent,
            })
            .then((elem) => {
              // console.log(elem)
              // console.log('idEnclousers', idEnclousers)
              this.widokBtn = false
              this.widok =  'C'
              this.$store.dispatch("products/get_selected_elements", {
                centrala: idCentral,
                moduly: idModules,
                obudowa: idEnclousers[0],
              });
            });
        });
    },
    clickModul() {
      console.log("----- clickModul -----");
      // console.log(this.inputFields.moduly)

      // const idCentrals = this.inputFields.centrala.idcentrala;
      const idModules =
        Object.keys(this.inputFields.moduly).length > 0
          ? this.inputFields.moduly.map((modules) => modules.idmodul)
          : [];

      this.inputFields.producent =
        this.inputFields.moduly && this.inputFields.moduly[0]
          ? this.inputFields.moduly[0].producent
          : "";

      this.$store
        .dispatch("products/load_obudowy", {
          centrala: this.inputFields.centrala ? this.inputFields.centrala : [],
          moduly: idModules,
        })
        .then((item) => {
          var ids = [];
          if (Object.keys(this.obudowy).length > 0) {
            Object.values(this.obudowy).forEach((item) => {
              ids.push(item.id_obudowa);
            });
          }
          this.widokBtn = false
          this.widok =  'C'
          this.$store.dispatch("products/get_selected_elements", {
            centrala: this.inputFields.centrala.idcentrala,
            moduly: idModules,
            obudowa: ids[0],
          });
        });
    },
    showFilters() {
      this.showDialogFilters = true;
      console.log("showFilters");
    },
    filtrujObudowy() {
      console.log("----- filtrujObudowy -----");
      const idModules =
        Object.keys(this.inputFields.moduly).length > 0
          ? this.inputFields.moduly.map((modules) => modules.idmodul)
          : [];
      this.$store
        .dispatch("products/load_obudowy", {
          centrala: this.inputFields.centrala,
          moduly: idModules,
          filters: this.inputFilters,
        })
        .then((item) => {
          var ids = [];
          if (Object.keys(this.obudowy).length > 0) {
            Object.values(this.obudowy).forEach((item) => {
              ids.push(item.id_obudowa);
            });
          }
          this.widokBtn = false
          this.widok =  'C'
          this.$store.dispatch("products/get_selected_elements", {
            centrala: this.inputFields.centrala.idcentrala,
            moduly: idModules,
            obudowa: ids[0],
          });
        });
      // .then(item => {
      //   var ids = [];
      //   if (Object.keys(this.obudowy).length>0) {
      //     Object.values(this.obudowy).forEach(item => {
      //       ids.push(item.id_obudowa)
      //     })
      //   }
      //   this.$store.dispatch("products/get_selected_elements", {'centrala': this.inputFields.centrala.idcentrala, 'moduly': idModules, 'obudowa': ids[0]})
      // })

      // this.filterParams()
      // this.$store.dispatch("products/load_obudowy", {'centrala': this.inputFields.centrala, 'filters': this.inputFilters})
    },
    load_centrale() {
      this.$store.dispatch("products/load_centrale");
      // this.lista.central = JSON.parse(JSON.stringify(this.centrale))
    },
    load_moduly() {
      this.$store.dispatch("products/load_moduly");
      // this.lista.central = JSON.parse(JSON.stringify(this.centrale))
    },
    nameWithLang({ name, language }) {
      return `${name} — [${language}]`;
    },
    changeModuler(item, modul, no, nomod) {
      // console.log(item, modul, no, nomod)
      var modulSelected = this.moduly.filter(
        (el) => el.idmodul == modul.id_modul
      );
      var tmpCheck = item.target.checked;

      // var myCheckbox = document.getElementsByName("check");
      // Array.prototype.forEach.call(myCheckbox,function(el){
      //   el.checked = true;
      // });

      if (tmpCheck) {
        // this.additional.push(no)
        this.inputFields.modulPlaceIndex.push(no);
        console.log(this.inputFields.modulPlaceIndex);
        this.$store.commit("products/SET_VAR_STATE", [
          JSON.parse(JSON.stringify(this.inputFields.modulPlaceIndex)),
          "inputData",
          "indexModul",
        ]);
        // this.additional.push(no)
        //   item.target.checked = tmpCheck;
        //   this.inputFields.modulPlaceIndex = no
        //   // modulSelected = modulSelected[0]
        //   // modulSelected['pozycja'] = modul
        //   // let p2 = Object.assign({}, modulSelected);
        //   // this.selectedModul = p2
      } else {
        var index = this.inputFields.modulPlaceIndex.indexOf(no);
        this.inputFields.modulPlaceIndex.splice(index, 1);
        console.log(this.inputFields.modulPlaceIndex);
        //eval(uneval(o))
        //Object.assign({}, this.inputFields.modulPlaceIndex)
        //JSON.parse(JSON.stringify(o))
        this.$store.commit("products/SET_VAR_STATE", [
          JSON.parse(JSON.stringify(this.inputFields.modulPlaceIndex)),
          "inputData",
          "indexModul",
        ]);
        // var index2 = this.additional.indexOf(no)
        // console.log(this.inputFields.modulPlaceIndex)
        // console.log(this.additional)
        // var index = this.additional.indexOf(no)
        // this.additional.splice(index2, 1)
        // this.$store.commit('products/SET_VAR_STATE', [this.additional, 'inputData','indexModul'])
        // console.log(this.inputFields.modulPlaceIndex)
        // console.log(this.additional)

        //   item.target.checked = tmpCheck
        //   this.inputFields.modulPlaceIndex = null
        //   // modulSelected['pozycja'] = []
        //   // this.selectedModul = {}
      }

      // console.log(item)
      // console.log(item.target.checked)
      // if (item.target.checked) {
      //   item.target.checked = false;
      //   modulSelected = []
      //   modulSelected['pozycja'] = []
      // } else {
    },
    addModul() {
      if (this.countBoxModules === 4) {
      } else {
        this.countBoxModules++;
      }
      console.log("----- addModul -----");
    },
    deleteModul() {
      if (this.countBoxModules === 1) {
      } else {
        if (Object.keys(this.inputFields.moduly).length > 1) {
          this.inputFields.moduly.pop();
          this.clickModul();
        }
        this.countBoxModules--;
      }
      console.log("----- deleteModul -----");
    },
    clickEye(item) {
      if (this.eyes.includes(item)) {
        var index = this.eyes.indexOf(item);
        if (index !== -1) {
          this.eyes.splice(index, 1);
        }
      } else {
        this.eyes.push(item);
      }
      // console.log('eyes', this.eyes)
    },
    zmienWidok (el) {
      this.widok = el
      this.widokBtn = true
    }
  },
  created() {
    this.widok = 'C'
    this.widokBtn = false
    this.selectedObudowa = [];
    this.$store.dispatch("products/get_selected_elements", []);
    this.load_centrale();
    this.load_moduly();
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>

h3 {
  margin: 15px;
font-size: 22px;
}
.kolumna-1 {
  width: 32%;
  padding: 10px;
  min-width: 336px;
  /* border-right: 3px solid #448aff;
  border-top: 3px solid #448aff; */
}
.kolumna-2 {
  /* background-color: #fff; */
  min-width: 336px;
  width: 68%;
  padding: 10px;
  /* border-top: 3px solid #448aff; */
}
.kolumna-21 {
  width: 100%;
  padding: 10px;
  min-width: 336px;
  /* border-right: 0px solid #448aff;
  border-top: 3px solid #448aff; */
}
.md-layout-item {
  margin-top: 15px;
}

#cards {
  width: 100%;
  display: inline-block;
  height: 340px;
  overflow-y: auto;
}
.md-card {
  width: 96%;
  height: 74px;
  float: left;
  cursor: pointer;
  margin: 2%;
  padding: 5px;
}
.md-card:hover {
  z-index: 2;
  background: #dff0ff;
}

#tab-centrale {
  display: inline-flex;
}
.md-card-header {
  padding: 0px !important;
}
md-card-header {
  padding: 0px !important;
}
md-card-content,
md-card-content:last-of-type {
  padding: 0px !important;
}
.md-card-content,
.md-card-content:last-of-type {
  padding: 0px !important;
}
.md-card .md-title {
  font-size: 18px;
  letter-spacing: 0;
  line-height: 20px;
  margin-bottom: 8px;
  margin-top: 15px;
}
.active {
  background: #dff0ff !important;
}

.lupka {
  position: relative;
  bottom: 22px;
  left: 0px;
  color: #254a80;
  text-align: right;
  width: 20px;
}

#selected-obudowa p {
  text-align: left;
  margin: 0;
  padding: 0;
  color: rgb(20, 121, 204);
}
fieldset {
  border: 1px solid grey;
  margin: 10px;
  padding: 8px;
  margin-top: 30px;
}
fieldset legend {
  font-size: 16px;
  background: #e6e4e4;
  margin-top: -18px;
  text-align: left;
  padding: 0px 10px;
}
fieldset legend img {
  cursor: pointer;
}
.md-dialog fieldset {
  border: 1px solid grey;
  margin: 10px;
  padding: 8px;
  margin-top: 30px;
}
.md-dialog fieldset legend {
  font-size: 16px;
  background: white;
  margin-top: -18px;
  text-align: left;
  padding: 0px 10px;
}
.md-dialog fieldset legend img {
  cursor: pointer;
}

.inputSelectProducent {
  background: rgba(242, 242, 242, 0.5);
  padding: 5px;
  width: 240px;
}
.inputSelectCentrala {
  background: rgba(255, 0, 0, 0.5);
  padding: 5px;
  width: 240px;
}
.inputSelect0 {
  background: rgba(64, 82, 182, 0.5);
  padding: 5px;
  width: 240px;
}
.inputSelect1 {
  background: rgba(77, 177, 79, 0.5);
  padding: 5px;
  width: 240px;
}
.inputSelect2 {
  background: rgba(255, 192, 9, 0.5);
  padding: 5px;
  width: 240px;
}
.inputSelect3 {
  background: rgba(116, 85, 75, 0.5);
  padding: 5px;
  width: 240px;
}
.inSelect {
  position: relative;
}
.oko {
  position: absolute;
  right: 0px;
  top: 15px;
}
.navView {
list-style: none;display: inline-flex;margin: 0px;padding: 0px;
}
.navView li {
width: 100px;padding: 2px;margin-right: 10px;cursor: pointer;border: 1px solid #d0cfcf;
}
.navView li:hover {
  border: 1px solid #aaaaaa;
}
.activeView {
background: #d0d0d0;
}
</style>



// WEBPACK FOOTER //
// src/components/DopasujObudowe.vue